module.exports = __webpack_public_path__ + "static/media/gonerdify.net_Personal_Nerd.5fc12b49.png";